import React, { HTMLAttributes, useEffect } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import Layout from "components/Layout";
import Banner from "./cell/banner";
import Content from "./cell/content";
import Blockchain from "./cell/blockchain";
import Smart from "./cell/smart";
import Trading from "./cell/trading";
import Glossary from "./cell/glossary";

// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;
  useEffect(() => {
    const htmlEl = document.documentElement;
    htmlEl.style.fontSize = "39px";
  }, []);

  return (
    <Layout>
      <div className={cx(styles.main, className)}>
        <Banner />
        <Content />
        <Blockchain />
        <Smart />
        <Trading />
        <Glossary />
      </div>
    </Layout>
  );
};

export default observer(Main);
// export default Main;
